/* eslint-disable react/require-default-props */

/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';

const propTypes = {
    title: PropTypes.string,
};

function PageMeta({ title = null }) {
    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    );
}

PageMeta.propTypes = propTypes;

export default PageMeta;
